import React, { useState } from "react";
import { connect } from "react-redux";
import Drawer from "../../Common/Drawer/Drawer";
import StarRatingComponent from "react-star-rating-component";

import { AXIOS } from "../../../Utilities/HttpRequest/Axios";
import { ToastContainer, toast } from "react-toastify";
import { WorkflowStates, UserType } from "../../../Constants/Enums";
import { AppConfiguration } from "read-appsettings-json";
import "./ExternalFeedbackDrawer.scss";
import { trackPromise } from "react-promise-tracker";

class ExternalFeedbackDrawer extends React.Component {
  state = {
    showFeedbackDrawer: false,
    overallRating: 0,
    isFeedbackProvided : false,
  };

  userFeedbackNote = '';

  constructor(props) {
    super(props);
    this.feedback = React.createRef();
  }

  componentDidMount() {
    this.setState({isFeedbackProvided : false});
  }

  render() {
    let drawer = this.createDrawer();
    const feedbackButton = "Add Feedback";
    return (
      <>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <button className="feedback-btn" onClick={this.toggleFeedbackDrawer}>
          <h3>{feedbackButton}</h3>
        </button>
      </div>
        {drawer}
      </>
    );
  }

  createDrawer = () => {
    const header = this.createFeedbackHeader();
    const body = this.createFeedbackBody();
    const footer = this.createFeedbackFooter();

    return (
      <Drawer
        size={"md"}
        open={this.state.showFeedbackDrawer}
        header={header}
        body={body}
        footer={footer}
      ></Drawer>
    );
  };

  createFeedbackHeader = () => {
    return (
      <>
        <h2 className="d-flex align-items-center">Provide Feedback</h2>
        <div className="panel-header-actions">
          <button
            className="action-btn panel-close"
            onClick={this.toggleFeedbackDrawer}
          >
            <i className="ba-icn ba-icn-close"></i>
          </button>
        </div>
      </>
    );
  };

  createFeedbackBody = () => {
    const isTenant =
      localStorage.getItem("userType") == UserType.Tenant  ;
    const jobData = this.props.jobDetails;

    let {
      overallRating,
      isFeedbackProvided,
    } = this.state;

    if (jobData.bidFeedBackList && jobData.bidFeedBackList.length > 0) {
      const userId = jobData.serviceConsumerId
      const userFeedback = jobData.bidFeedBackList.filter(
        feedback => feedback.userId === userId
      );
      if (userFeedback && userFeedback.length > 0) {
        const feedbackGivenByUser = userFeedback[0];
        isFeedbackProvided = true;
        this.userFeedbackNote = feedbackGivenByUser.feedback;
        if(feedbackGivenByUser.bidRatings.length > 0){
          overallRating = feedbackGivenByUser.bidRatings.filter(
            rating => rating.ratingsCriteriaId === 1
          )[0].rating;
        }
       
      }
    }


    return (
      <div className="panel-body job-detail-card feed-bk-drwr">
        <h5 className="mb-0">{jobData.title}</h5>
        <div className="job-description">{jobData.description}</div>
        <div className="job-details-table">
        {(!isTenant ) ?
          <div className="job-details-table-row">
            <div className="table-label">Estimate</div>
            <div className="table-data mb-3">
              {jobData && jobData.acceptedBid && jobData.acceptedBid.amount && jobData.acceptedBid.amount > 0 ? `$ ${jobData.acceptedBid.amount}` : "Not Supplied"}
            </div>
          </div>
           : ''}
          <div className="job-details-table-row">
            <div className="table-label">Provider</div>
            <div className="table-data mb-3">
              {jobData.acceptedBid ? `${jobData.acceptedBid.name}` : ``}
            </div>
          </div>
          <div className="job-details-table-row">
            <div className="table-label">Provider Note</div>
            <div className="table-data mb-3" dangerouslySetInnerHTML={{ __html: jobData.serviceProviderNote }}>
            </div>
          </div>
        </div>

        <hr></hr>

        <h3 className="my-3">Overall Rating</h3>
        <div className="job-details-table">

          <div className="job-details-table-row valign-middle">
            <div className="table-data">
              <StarRatingComponent
                name="overallRating"
                starCount={5}
                value={overallRating}
                onStarClick={this.onRatingStarClick.bind(this)}
              />
            </div>
          </div>
        </div>
        {!isFeedbackProvided &&
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label className="table-label">Feedback</label>
                <textarea
                  className="form-control"
                  id="txtFeedback"
                  rows="3"
                  ref={this.feedback}
                ></textarea>
              </div>
            </div>
          </div>}
        {isFeedbackProvided &&
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label className="table-label">Feedback</label>
                <textarea
                  className="form-control"
                  id="txtFeedback"
                  rows="3"
                  value={this.userFeedbackNote}
                  ref={this.feedback}

                ></textarea>
              </div>
            </div>
          </div>
        }
        {this.props.jobDetails.propertyManagerAgencyPlaceId != '' || this.props.jobDetails.providerAgencyPlaceId != '' ?
          <div className="row">
            <div className="col-sm-12 my-3">
              <div className="btn-group mb-3">
                <button className={this.props.jobDetails.providerAgencyPlaceId == '' ? "d-none" : "btn btn-outline-primary mr-1 bigger-btn mb-3"}
                  onClick={() => this.onClickAddReview(this.props.jobDetails.providerAgencyPlaceId)}>
                  <span>Add review to Service Provider's Agency</span>
                </button>
                <button className={this.props.jobDetails.propertyManagerAgencyPlaceId == '' ? "d-none" : "btn btn-outline-primary bigger-btn mb-3"}
                  onClick={() => this.onClickAddReview(this.props.jobDetails.propertyManagerAgencyPlaceId)}>
                  <span>Add review to Property Manager's Agency</span>
                </button>
              </div>
            </div>
          </div> : ''
        }
        <div className="row d-none">
          <div className="col-sm-12">
            <div className="form-group">
              <div className="custom-control custom-checkbox">
                <input
                  name="markAsCompleted"
                  type="checkbox"
                  id="1"
                  className="custom-control-input"
                />
                <label
                  title=""
                  type="checkbox"
                  htmlFor="1"
                  className="custom-control-label"
                >
                  {" "}
                  Mark as Completed
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  onClickAddReview = (placeId) => {
    let url = AppConfiguration.Setting().googleMapReviewUrl + "?placeid=" + placeId;
    window.open(url, "_blank")
  }


  onRatingStarClick(nextValue, prevValue, name) {
    switch (name) {
      case "overallRating":
        this.setState({ overallRating: nextValue });
    }
  }

  createFeedbackFooter = () => {
    const feedbackButton = "Save";
    const jobData = this.props.jobDetails;
    let {
      isFeedbackProvided,
    } = this.state;
    return (
      <>
        <div className="card-actions mb-3">
          <button className="more-actions" onClick={this.toggleFeedbackDrawer}>
            {" "}
            Cancel{" "}
          </button>

          {!isFeedbackProvided && <button onClick={this.onUpdateFeedback}>
            <i className="ba-icn ba-icn-ok"></i> {feedbackButton}{" "}
          </button>}
        </div>
      </>
    );
  };

  onUpdateFeedback = () => {
    try {
      if (!this.state.overallRating) {
        toast.error("Please select feedback!", {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        return;
      }
      this.props.showJobDetailsDrawer(!this.props.open, true);
      let bidFeedback = {
        userId: localStorage.getItem("userId"),
        jobId: this.props.jobDetails.id,
        feedback: this.feedback.current.value,
        bidRatings: [
          { rating: this.state.overallRating, ratingsCriteriaId: 1 },
          { rating: this.state.overallRating, ratingsCriteriaId: 2 },
          { rating: this.state.overallRating, ratingsCriteriaId: 3 },
          { rating: this.state.overallRating, ratingsCriteriaId: 4 }
        ],
        FeedBackUserType: UserType.Owner,
        FeedbackRatings: 0
      };
      trackPromise(
        AXIOS.POST(`tenant-api/save-feedback`, bidFeedback).then(response => {          
          if (response.success === true) {
            this.setState({
             isFeedbackProvided: true
              }, () => {
                this.createFeedbackFooter();
              });
            this.userFeedbackNote = this.feedback.current.value;
            toast.success("Feedback Updated.", {
              position: toast.POSITION.BOTTOM_RIGHT
            });
            window.location.reload();
          } else {
            toast.error("Error occured. Please try again.", {
              position: toast.POSITION.BOTTOM_RIGHT
            });
          }
        }));
    } catch (error) {
      console.log(error);
    }
  };

  toggleFeedbackDrawer = () => {
    this.setState(state => ({
      showFeedbackDrawer: !this.state.showFeedbackDrawer
    }));
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    open: state.MyJobs.isOpen
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showJobDetailsDrawer: (isShowDrawer, isRefresh) => {
      dispatch({
        type: "SHOW_JOB_DETAILS_DRAWER",
        isOpen: isShowDrawer,
        refreshMyJobs: isRefresh
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalFeedbackDrawer);
